:host {
  display: block;
  font-family: var(--font-family-primary);
  font-size: var(--font-size-sm);
  padding: 0 var(--spacing-comp-01) 0 var(--spacing-comp-01);
  cursor: pointer;
  display: flex;
  align-items: center;
  height: var(--spacing-comp-05);
  opacity: 1;
  transition: all 0.25s;
  overflow: hidden;
  color: var(--color-on-background);
}
:host gxg-icon {
  margin-inline-end: var(--spacing-comp-01);
}
:host .text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: calc(100% - 24px);
}

:host(:hover) {
  background-color: var(--color-secondary-enabled);
}

:host(.opacity-zero) {
  opacity: 0;
}

:host(.height-zero) {
  height: 0;
}

:host(.exact-match) {
  color: var(--color-success-dark);
}

:host(.exact-match:hover) {
  color: var(--color-success-dark);
  background-color: var(--color-success-light);
}

:host(:focus) {
  outline: none;
  outline-color: var(--color-primary-active);
  box-shadow: var(--box-shadow-values) var(--color-primary-active);
}